import { Platform, StyleSheet, View } from 'react-native';

export default function LiquidEther() {
  return (
    <View pointerEvents="none" style={s.wrap}>
      <View style={s.blobA} />
      <View style={s.blobB} />
    </View>
  );
}

const s = StyleSheet.create({
  wrap: { ...StyleSheet.absoluteFillObject, overflow: 'hidden' },
  blobA: { position: 'absolute', width: 330, height: 330, borderRadius: 180, backgroundColor: '#5B21B666', top: -130, right: -80, ...(Platform.OS === 'web' ? ({ filter: 'blur(35px)' } as any) : {}) },
  blobB: { position: 'absolute', width: 280, height: 280, borderRadius: 160, backgroundColor: '#0891B255', bottom: -110, left: -90, ...(Platform.OS === 'web' ? ({ filter: 'blur(30px)' } as any) : {}) },
});
